export const cookieName = "peek_referrer";